import { SLIDES_PART_A } from "@/components/slides_part_a";
import { SLIDES_PART_B } from "@/components/slides_part_b";
import { SLIDES_PART_C } from "@/components/slides_part_c";

export const SLIDES = {
  ...SLIDES_PART_A,
  ...SLIDES_PART_B,
  ...SLIDES_PART_C,
};
